import TopAssets from './TopAssets';

export default TopAssets;
